import Bugsnag from "@bugsnag/js";
import { User } from "_types/system";
import { storageVersion } from "./config";

function storage_get(key: string) {
  if (window.localStorage.getItem(`${key}Version`) === storageVersion) {
    const value = window.localStorage.getItem(key)
    if (value != null) return value
  }
  if (window.sessionStorage.getItem(`${key}Version`) === storageVersion) {
    const value = window.sessionStorage.getItem(key)
    if (value != null) return value
  }
  return null
}

function storage_set(key: string, value: string, storage: Storage) {
  storage.setItem(`${key}Version`, storageVersion)
  storage.setItem(key, value)
}

export const storeSession = (user: User, keepSignedIn: boolean) => storage_set(
  'user',
  JSON.stringify(user),
  keepSignedIn ? window.localStorage : window.sessionStorage
)

export const deleteSession = () => {
  window.localStorage.removeItem('user');
  window.sessionStorage.removeItem('user');
}

export const restoreSession: () => User | null = () => {
  const user_json = storage_get('user')
  if (!user_json) return null
  try {
    const user = JSON.parse(user_json)
    if (user.authToken) {
      return user
    } else {
      throw TypeError('authToken not present')
    }
  } catch(e) {
    // TODO: add {metaData: {user_json}})
    Bugsnag.notify(e);
    deleteSession()
    return null;
  }
}
